// lib/funnels/functions/v1/metrics/captureEvent.js
import * as Sentry from '@sentry/browser'
import { sendMetric } from './sendMetric'
import { getUserId } from './userId'

/**
 * Captures metric event
 *
 * @param {string} event - event name
 * @param {Object.<string, string|number>} data - extra data
 */
export function captureEvent(event, data = {}) {
  const { href, pathname, origin, search } = window.location
  const name = `${event}@${origin}${pathname}`
  const userId = getUserId()

  // Get today's date for unique tracking
  const today = new Date().toISOString().split('T')[0]
  const uniqueKey = `clicked_${event}_${today}`

  // Check if user already clicked this today
  const todayClicks = JSON.parse(localStorage.getItem(uniqueKey) || '{}')
  const isUniqueClick = !todayClicks[userId.id]

  // Mark as clicked for today
  todayClicks[userId.id] = {
    timestamp: new Date().toISOString(),
    type: userId.type,
  }
  localStorage.setItem(uniqueKey, JSON.stringify(todayClicks))

  sendMetric(event.replace(/^form-/i, ''), href)

  // Main span for the event
  Sentry.startSpan({ name, forceTransaction: true }, (span) => {
    span.setAttributes({
      // Location data
      href,
      pathname,
      origin,
      search,

      // User data
      'user.id': userId.id,
      'user.type': userId.type,
      'user.segment': userId.type,

      // Unique click tracking
      'click.is_unique_today': isUniqueClick,
      'click.date': today,
      'click.timestamp': new Date().toISOString(),

      // Fingerprint for grouping
      fingerprint: `${name}|${userId.id}`,

      // Additional data
      ...data,
    })

    return span
  })

  // Create a separate span for unique clicks
  if (isUniqueClick) {
    Sentry.startSpan(
      {
        name: `${event}-unique@${origin}${pathname}`,
        forceTransaction: true,
      },
      (span) => {
        span.setAttributes({
          href,
          pathname,
          origin,
          search,
          'user.id': userId.id,
          'user.type': userId.type,
          'click.date': today,
          'click.is_first_today': true,
          'click.timestamp': new Date().toISOString(),
          fingerprint: `${event}-unique|${userId.id}`,
          ...data,
        })

        return span
      },
    )
  }
}
